'use strict';

function getVehicleLabel(vehicle) {
  return vehicle
    ? `${vehicle.plate} - ${vehicle.number} - ${vehicle.description}`
    : '';
}

// eslint-disable-next-line no-unused-vars
function VehicleLabel() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {
      vehicle: '<'
    },
    // eslint-disable-next-line no-unused-vars
    link: function(scope) {
      const { vehicle } = scope;
      scope.vehicleLabel = getVehicleLabel(vehicle);
    },
    template: '{{ vehicleLabel }}'
  };
}

export { VehicleLabel as default, getVehicleLabel };
